import Api from "../../../../util/Api";

export default function getInitState() {
    return {
        dataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        actions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            },
            {
                btn_text: '<i class="fas fa-plus"></i> Exportálás',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'export'
            }
        ],
        searchFields: [
            {
                name: "doctorId",
                label: "Orvos",
                formSize: 3,
                formType: 'select',
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getAllDoctorForEesztReport,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "patientName",
                label: "Páciens",
                formType: "text",
                formVisible: true,
                formSize: 3
            },
            {
                name: "socialInsuranceNumber",
                label: "TAJ",
                formType: "text",
                formVisible: true,
                formSize: 3
            },
            {
                name: "documentTypeId",
                label: "Dokumentum típus",
                formVisible: true,
                formSize: 3,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getClinicList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "documentCreatedOnFrom",
                label: "Dokumentum létrehozása (tól)",
                formSize: 3,
                formVisible: true,
                formType: "date"
            },
            {
                name: "documentCreatedOnTo",
                label: "Dokumentum létrehozása (ig)",
                formSize: 3,
                formVisible: true,
                formType: "date"
            }
        ],
        headerFields: [
            {
                name: "doctorName",
                label: "Orvos",
                visibility: true,
                sort: true
            },
            {
                name: "patientName",
                label: "Páciens neve",
                visibility: true,
                sort: true
            },
            {
                name: "socialInsuranceNumber",
                label: "TAJ",
                visibility: true,
            },
            {
                name: "dateOfBirth",
                label: "Születési dátum",
                visibility: true,
                slot_name: "date_format"
            },
            {
                name: "documentType",
                label: "Dokumentum típus",
                visibility: true,
                sort: true
            },
            {
                name: "documentCreatedOn",
                label: "Dokumentum létrehozva",
                visibility: true,
                slot_name: "appointment_format"
            },
            {
                name: "errorMessage",
                label: "EESZT hiba",
                visibility: true,
            }
        ]
    }
}
